export default {
  case: "Case",
  caseNumber: "Case number",
  myApplications: "My cases",
  approvalRequest: "Approval request",
  applicant: "Initiator",
  applicationType: "Case type",
  currentStep: "Current step",
  status: "Status",
  submittedAt: "Created",
  completedAt: "Completed",
  caseStatus: {
    draft: "Draft",
    inProgress: "In review",
    returned: "Returned",
    completed: "Completed",
    canceled: "Canceled",
    suspended: "Suspended",
    error: "Error",
  },
} as const;
